<script setup>
import { computed } from 'vue'
import { inject } from 'vue'
import AddressDisplay from './AddressDisplay.vue'

const props = defineProps({
  formMetadata: {
    type: Object,
    required: true
  }
})

const formValues = inject('formValues', {})

const agentType = computed(() => {
  return formValues.registered_agent_type === 'P' ? 'Person' : 'Corporation'
})

const agentName = computed(() => {
  if (formValues.registered_agent_type === 'P') {
    const parts = []
    if (formValues.registered_agent_first_name)
      parts.push(formValues.registered_agent_first_name)
    if (formValues.registered_agent_middle_name)
      parts.push(formValues.registered_agent_middle_name)
    if (formValues.registered_agent_last_name)
      parts.push(formValues.registered_agent_last_name)
    return parts.join(' ')
  } else {
    return formValues.registered_agent_name
  }
})

const addressData = computed(() => {
  return {
    address_1: formValues.registered_agent_address_1,
    address_2: formValues.registered_agent_address_2,
    city: formValues.registered_agent_city,
    state: formValues.registered_agent_state,
    zip: formValues.registered_agent_zip
  }
})

const hasSignature = computed(() => {
  return !!formValues.registered_agent_signature
})
</script>

<template>
  <div class="registered-agent-display">
    <!-- Agent Information Section -->
    <div class="agent-info mb-4">
      <h4 class="agent-name mb-1">{{ agentName }}</h4>
      <p class="agent-type text-muted mb-0">
        <i
          class="fa-light fa-user me-1"
          v-if="formValues.registered_agent_type === 'P'"
        ></i>
        <i class="fa-light fa-building me-1" v-else></i>
        {{ agentType }}
      </p>
    </div>

    <!-- Address Section -->
    <div class="address-section mb-4">
      <div class="section-header mb-2">
        <h6 class="text-muted mb-0">
          <i class="fa-light fa-location-dot me-2"></i>
          Address
        </h6>
      </div>
      <AddressDisplay :addressData="addressData" />
    </div>

    <!-- Signature Section (if present) -->
    <div
      v-if="hasSignature"
      class="signature-section p-3 bg-light border rounded mb-3"
    >
      <div class="d-flex align-items-center">
        <i class="fa-light fa-signature text-success me-2"></i>
        <div>
          <small class="text-muted d-block">Authorized Signature</small>
          <span class="fw-medium">{{
            formValues.registered_agent_signature
          }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
